import { IsDefined, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { Transform } from 'class-transformer';

export enum EcomProductType {
  Accessories = 'accessories',
  AccessoryPackages = 'accessorypackages',
  Insurance = 'insurancesList',
  InsuranceAddons = 'insuranceAddons',
  ServicePackage = 'servicesList',
  ExtendedWarranty = 'extendedWarrenty',
  CustomerCarePackage = 'customerCarePackages',
  TPL = 'tplPrice',
  Registration = 'registrationPrice',
  CashBack = 'cashBack',
  Finance = 'finance',
}

export class EcomBaseProduct {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Transform((p) => p?.toString(), { toClassOnly: true })
  productID!: string;

  @IsDefined()
  @IsString()
  productTitle!: string;

  @IsOptional()
  @IsString()
  productDescription?: string;

  @IsOptional()
  @IsString()
  productCurrency?: string;
}
